import React from 'react';
import { useNewsList } from './../../queries/news';
import { useNewsPageHeader } from './../../queries/newsPageHeader';
import PageWrapper from './../../components/PageWrapper/index';
import Header from './../../components/Header/index';
import PageHeader from './../../components/PageHeader/index';
import Footer from './../../components/Footer/index';
import ToolBarMenu from './../../components/ToolBarMenu/index';
import NewsContent from './NewsContent';
import { useAnnouncement } from './../../queries/announcement';
import AnnouncementList from '../Announcement/AnnouncementsList';
import InfinitProgressBar from '../../components/InfiniteProgressBar';

const News = () => {

    const {data, error, loading} = useNewsList();
    const AnnouncementData = useAnnouncement();
    const newsPage = useNewsPageHeader();
    if(!data){
        return;
    }
    if (newsPage.error) return <div>error!</div>
    if (newsPage.loading) return <InfinitProgressBar /> 

    if (error) return <div>error!</div>
    if (loading) return <InfinitProgressBar /> 
    if(!AnnouncementData.data){
        return;
    }
    if (AnnouncementData.error) return <div>error!</div>
    if (AnnouncementData.loading) return <InfinitProgressBar /> 

    if (newsPage.error) return <div>error!</div>
    if (newsPage.loading) return <InfinitProgressBar /> 

    const AnnouncmentHeaderImage = AnnouncementData.data.announcementTopHeader[0].announcementPageHeaderImage.urls[0]
    return (  
        <PageWrapper>
            <div>
                {/* <ToolBarMenu/> */}
                <Header/>
                <PageHeader
                    // bgImg={require('../../assets/img/page-header.jpg')}
                    // title={'اخبار و آگهی ها'}
                    // content={''} 
                    bgImg={newsPage.data.newsPageHeader[0].newsPageHeaderImage.urls[0]}
                    title={newsPage.data.newsPageHeader[0].displayText}
                    content={newsPage.data.newsPageHeader[0].newsPageHeaderSubtitle.html}
                />

                <br/>
                <br/>

                <div style={{width:"100%", height:"80px", display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                    <h3>اخبار</h3>
                    <hr style={{width:'20%', height:'2px', backgroundColor:'red'}}/>
                </div>

                <br/>
                <br/>
{ data ?
    <NewsContent data={data.news} classes='order-0 order-lg-1'/> : null
}
                

                <br/>
                <br/>
                <br/>
                <br/>

                <div style={{width:"100%", height:"80px", display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                    <h3>آگهی</h3>
                    <hr style={{width:'20%', height:'2px', backgroundColor:'red'}}/>
                </div>

                <div style={{width:"100%", height:"auto", maxHeight:'400px', overflowY:"auto"}} >
                    <div className="my-history-area mem-achieve-item">
                        <div className="history-content-wrap how-we-works-content mt-40 mt-sm-30">
                            { AnnouncementData.data ?
                                AnnouncementData.data.announcement.map(i=>(
                                   <AnnouncementList icon={i.announcementIcon.urls[0]} Title={i.displayText} description={i.htmlBody.html} date={i.announcementDate} alias={i.alias.alias} topImage={AnnouncmentHeaderImage}/>
                                )) : null
                            }
                        </div>
                    </div>
                </div>
                

                <br/>
                <br/>
                <br/>

                <Footer/>

            </div>
        </PageWrapper>
    );
}
 
export default News;